import apiSlice from "./apiSlice";
const documentApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllActivities: builder.query({
            query: (req) => ({
                url: `EngineeringActivity`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllActivities"],
        }),

        getAllDocuments: builder.query({
            query: (req) => ({
                url: `EngineeringDocuments`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllDocuments"],
        }),

        getPendingDocuments: builder.query({
            query: (req) => ({
                url: `EngineeringDocuments/Pending`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PendingDocuments"],
        }),

        getSubmittedDocuments: builder.query({
            query: (req) => ({
                url: `EngineeringDocuments/Submitted`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["SubmittedDocuments"],
        }),

        updateDocumentStatus: builder.mutation({
            query: (body) => ({
                url: `EngineeringDocuments/any-id`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['DocumentDetail']
        }),

        updateReSubmitDoc: builder.mutation({
            query: ({ body, id }) => ({
                url: `EngineeringDocuments/ReSubmitDoc/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['SubmittedDocuments']
        }),

        addDocument: builder.mutation({
            query: (body) => ({
                url: `EngineeringDocuments`,
                method: 'POST',
                body,
            })
        }),
        documentDetail: builder.query({
            query: ({ req, id }) => ({
                url: `EngineeringDocuments/${id}`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["DocumentDetail"],
        }),
    }),
});

export const { useUpdateReSubmitDocMutation,
    useGetAllActivitiesQuery,
    useGetAllDocumentsQuery,
    useGetPendingDocumentsQuery,
    useGetSubmittedDocumentsQuery,
    useUpdateDocumentStatusMutation,
    useAddDocumentMutation,
    useDocumentDetailQuery
} = documentApiSlice;
